<template>
  <v-dialog v-model="dialogVisible" persistent width="200">
    <v-card
      class="d-flex flex-column justify-center align-center"
      style="width: 200px; height: 200px;"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    dialogVisible() {
      return this.isLoading;
    },
  },
};
</script>
